export const selectIsFetching = state => state.integrations.isFetching;

export const selectError = state => state.integrations.error;
